<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>模板配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
           <el-card shadow="hover"  class="searchCard" >
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >新增模板配置</el-button>  
           </el-card>
           <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange" 
            v-loading="loading"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" > 
                <el-table-column prop="name" width="120" align="left" label="配置名称"></el-table-column>     
                <el-table-column prop="detail" width="160" align="left" label="配置说明"> </el-table-column>     
                <el-table-column prop="serviceTel" min-width="160" align="left" label="客服号码"> </el-table-column>     
                <el-table-column prop="serviceLink" min-width="160" align="left" label="客服链接">
                    <template slot-scope="scope" >  
                        <el-link type="primary" @click="copyLink('客服链接',scope.row.serviceLink)" style="font-size:12px">{{scope.row.serviceLink}}</el-link>
                    </template> 
                </el-table-column>     
                <el-table-column prop="status" width="80" align="left" label="配置状态">
                    <template slot-scope="scope" >  
                        <el-tooltip :content="scope.row.status=='1'?'已启用':'已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column>     
                <el-table-column prop="createTime" width="165" align="left" label="创建时间"> </el-table-column>     
                <el-table-column prop="updateTime" width="165" align="left" label="修改时间"> </el-table-column>      
                <el-table-column label="操作" width="140" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column> 
            </el-table> 
           </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增落地页配置" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form1" :model="form1" label-width="80px" @submit.native.prevent="saveForm">
                <el-form-item label="配置名称">
                    <el-input v-model.trim="form1.name"  placeholder="不超过10个字" ></el-input>
                </el-form-item>  
                <el-form-item label="模板说明">
                    <el-input v-model.trim="form1.detail"  placeholder="不超过50个字" ></el-input>
                </el-form-item> 
                <el-form-item label="客服号码">
                    <el-input v-model.trim="form1.serviceTel"  placeholder="不超过10个字" ></el-input>
                </el-form-item>
                <el-form-item label="客服链接">
                    <el-input type="textarea" v-model.trim="form1.serviceLink"  placeholder="不超过10个字" ></el-input>
                </el-form-item>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
        
       
        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="修改落地页配置" :visible.sync="editVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form2" :model="form2" label-width="80px">
                <el-form-item label="配置名称">
                    <el-input v-model.trim="form2.name"  placeholder="不超过10个字"></el-input>
                </el-form-item>  
                <el-form-item label="模板说明">
                    <el-input v-model.trim="form2.detail"  placeholder="不超过50个字"></el-input>
                </el-form-item> 
                <el-form-item label="客服号码">
                    <el-input v-model.trim="form2.serviceTel"  placeholder="不超过10个字"></el-input>
                </el-form-item>
                <el-form-item label="客服链接">
                    <el-input type="textarea" v-model.trim="form2.serviceLink"  placeholder="不超过10个字"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
`   `
        
          
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus,fetchDataDir,getFormartImg,getFilesDetail} from '../../api/h5templateConfig';  
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            select6:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            query2: { 
                pageIndex: 1,
                pageSize: 5,  
            },
            templateId:'',
            fileList:[],
            dialogImageUrl:'',
            dialogVisible:false,
            imgVisible:false,
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            linkVisible:false,
            row:{},
            pageTotal: 0,
            pageTotal2: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                ctype:'2',  
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        copyLink(name,text){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },
        getLink(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            var link = name+"： http://"+host+"/h5/cl/"+this.templateId+"_"+mid+"/"+goodsCode;
            this.copyLink(name,link);
        },
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name', '');  
            this.$set(this.query, 'status');    
            this.getData();
        },
        // 触发搜索按钮 
        handleSearch2() {
            this.$set(this.query2, 'pageIndex', 1);
            this.getData2();
        },

        //重置按钮
        refreshSearch2(){ 
            this.$set(this.query2, 'goodsName', '');  
            this.$set(this.query2, 'channelCode');    
            this.getData2();
        },  
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 
        handleLink(index,row){
            this.templateId = row.path;
            //查询列表数据
            this.loading =true; 
            this.getSelect6();
            this.getData2();  
            setTimeout(() => {
                this.loading =false;
                this.linkVisible = true;
            }, 1000); 
        },
        getSelect6(){ 
            this.select6 = {};  
            fetchSelect6(this.select6).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        },

        //查询
        getData(){ 
            this.query.stationId = this.stationId;  
            this.query.mid = this.mid;
            this.query.secret = this.secret; 
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        getData2(){
            // 获取列表数据    
            fetchData2(this.query2).then(res => {   
                if(res.code=='200'){ 
                    this.tableData2 = res.data.list;
                    this.pageTotal2 = res.data.pageTotal ;   
                }else{
                    this.tableData2 = []; 
                    this.pageTotal2 = 0; 
                } 
                
            });
        },
        //详情图上传成功追加数据 
        handleChange(file,fileList) {  
            const isJPG =file.raw.type === "image/png" || file.raw.type === "image/jpg" || file.raw.type === "image/jpeg";
            const isLt5M = file.size / 1024   < 1024;
            if (!isJPG) {
                this.$message.error("上传图片只能是 jpg、jpeg、png 格式!");
                fileList.splice(-1, 1);//移除错误文件
                return false;
            }
            if (!isLt5M) {
                this.$message.error("上传图片单张大小不能超过 1MB!");
                fileList.splice(-1, 1);
                return false;
            }  
            this.fileList = fileList;	  
            
        }, 
        //删除图片 
        handleRemove(file, fileList) {  
            let a = file.url ;
            let b = this.form1.detailPlain.indexOf(a);
            this.form1.detailPlain.splice(b,1);
            this.dialogImageUrl.splice(b,1); 
        }, 
        handleRemove(file) {   
            let i = this.fileList.indexOf(file);   
            this.fileList.splice(i,1); 
        }, 
         //详情图放大
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true; 
        }, 
        //文件上传超过最大数量提示
        overMaxImg(file,fileList){
            this.$message.error("图片最多只能上传3张"); 
        },

        // 新增渠道
        addBind() {
            this.addVisible = true; 
            this.fileList = [];
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写配置名称");
                return;
            }  
            if( !this.form1.serviceTel ){
                this.isSubmitting = false;
                this.$message.error("请填写客服电话");
                return;
            } 
            if( !this.form1.serviceLink ){
                this.isSubmitting = false;
                this.$message.error("请填写客服链接");
                return;
            }  
            this.loading = true;  
            this.loadingTitle = "正在保存..."; 
            setTimeout( () => {
                this.loading = false;  
                this.refreshSearch();
            }, 5000) 
            saveForm(this.form1).then(res => {
                this.loading = false;  
                this.isSubmitting = false;
                if(res.code='200'){
                    this.addVisible = false;
                    this.refreshSearch();
                    this.$message.success("添加成功"); 
                }else{
                    this.$message.error("添加异常:"+res.message); 
                }
            });  
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.form2 = row;
            this.editVisible = true; 
                   
        },
 
        
        // 保存更改
        saveEdit() {  
            if( !this.form2.name ){
                this.isSubmitting = false;
                this.$message.error("请填写配置名称");
                return;
            }  
            if( !this.form2.serviceTel ){
                this.isSubmitting = false;
                this.$message.error("请填写客服电话");
                return;
            } 
            if( !this.form2.serviceLink ){
                this.isSubmitting = false;
                this.$message.error("请填写客服链接");
                return;
            }  
            this.loading = true;  
            this.loadingTitle = "正在保存...";
            this.editVisible = false;  
            setTimeout( () => {
                this.loading = false;  
                this.refreshSearch();
            }, 5000)
            changeForm(this.form2).then(res => {
                this.loading = false;  
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.refreshSearch();
                }else{
                    this.$message.error(res.message); 
                }
            });  
 
        },
        getImgList(index,row){
            //文件回显    
            this.fileList = [];
            let data = {}; 
            data.temCode = row.code;
            getFilesDetail(data).then(res => {
                if(res.code=='200'){  
                    this.fileList = res.data;   
                    this.imgVisible = true;    
                }else{ 
                    this.$message.error(res.message); 
                } 
            });     
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                row.status = '1';
                this.$message.error('不能关闭该配置');
                return;
            } 
            row.status = '0';     
            // 二次确认删除
            this.$confirm('启用该配置，其他配置将关闭。确定启用该配置吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                row.status = '1';     
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('配置成功'); 
                        this.getData();
                    }else{ 
                        row.status = '0';     
                        this.$message.error('配置失败'+res.message);
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            if(row.status==1){
                this.$message.error("当前配置已启用，不可删除");
                return;
            }
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('去问删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else{
                        this.$message.error(res.message); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        handlePageChange2(val) { 
            this.$set(this.query2, 'pageIndex', val);
            this.getData2();
        },
        //分页数量更改导航
        handleSizeChange2(val){
            this.$set(this.query2, 'pageSize', val);
            this.getData2();
        }
    }
};
</script>

<style>

.el-upload-list--picture-card .el-upload-list__item{
    width:100px;
    height:100px ;
}
.el-upload--picture-card{
    width:100px ;
    height:100px ;
    line-height:100px ;
}
</style>
<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
